<ion-card
  (click)="openUrl(banner.Tipo.toLowerCase(), banner.Titulo, banner.Url_Pagina)"
>
  <div
    class="empty"
    *ngIf="banner.Url_Imagen === '' && banner.Url_Imagen === null"
  >
    <img src="./assets/blank_image.png" />
  </div>

  <ion-card-content class="card-content">
    <div class="contenedor-div" [ngClass]="thumbnailUrl">
      <div class="div-spinner">
        <div class="copa" style="height: 100%;">
          <ion-spinner name="lines"></ion-spinner>
        </div>
        <!-- <img [src]="thumbnailUrl" alt="" *ngIf="banner.Url_Imagen !== ''"> -->
      </div>
      <div style="position: relative;z-index: 1;">
        <img
          id="img"
          [src]="banner.Url_Imagen"
          alt=""
          *ngIf="banner.Url_Imagen !== ''"
        />
      </div>

      <div class="Oval">
        <ion-icon
          class="icon-card"
          [color]="banner.color"
          [name]="banner.Icon"
        ></ion-icon>
      </div>
    </div>
  </ion-card-content>

  <ion-card-content style="padding: 20px 0 0 0;">
    <p class="titulo">
      <b> {{ banner.Titulo }} </b>
    </p>
    <p
      class="contenido"
      style="color: #009bdd;"
      *ngIf="banner.Tipo === 'YouTube'"
    >
      {{ banner.Descripcion }}
    </p>
    <p class="contenido" *ngIf="banner.Tipo !== 'YouTube'">
      {{ banner.Descripcion }}
    </p>
  </ion-card-content>
</ion-card>
